// API Endpoints
export const API_ENDPOINTS = {
  USER_API: process.env.REACT_APP_USER_API_URL || 'https://lni1mjs1vl.execute-api.us-east-2.amazonaws.com/prod'
};

// XRP Constants
export const XRP_CONSTANTS = {
  DESTINATION_ADDRESS: 'rQK27bkjy4G3k8qjayqkuLEvFxhKLukDwG'
};

// App Constants
export const APP_CONSTANTS = {
  ODDS_API_KEY: '6a29c823da1291114dc121e3161e7c49',
  ODDS_API_BASE_URL: 'https://api.the-odds-api.com/v4'
}; 